import styled, { css } from 'styled-components';

export const Loader = styled.div<{fullheight?}>`
    height: calc(100vh - 10rem);
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
        margin-top: 2rem;
    }

    ${({ fullheight }) =>
        fullheight === "true" &&
        css`
            height: 100vh;
        `}
`;
